import { detectBlockchainInput } from './detectInput';

const CHAIN_LABELS = {
  ethereum: 'Ethereum',
  polygon: 'Polygon',
  evm: 'Ethereum / Polygon',
  block: 'Multi-chain',
  solana: 'Solana',
  tron: 'Tron',
  prc: 'PRC',
};

const TYPE_LABELS = {
  transaction: 'Transaction',
  address: 'Address',
  block: 'Block',
};

export function getChainLabel(chain) {
  return CHAIN_LABELS[chain] || chain;
}

export function getTypeLabel(type) {
  return TYPE_LABELS[type] || type;
}

/**
 * @returns {string | null}
 */
export function getSearchDestination(query) {
  const detection = detectBlockchainInput(query);
  if (!detection) {
    return null;
  }

  if (detection.type === 'transaction') {
    if (
      detection.chain === 'solana' ||
      detection.chain === 'tron' ||
      detection.chain === 'evm' ||
      detection.chain === 'prc'
    ) {
      return `/tx/${encodeURIComponent(detection.query)}`;
    }
  }

  if (detection.chain === 'prc' && detection.type === 'address') {
    return `/tx/${encodeURIComponent(detection.query)}`;
  }

  if (detection.type === 'block') {
    return `/tx/${encodeURIComponent(detection.query)}`;
  }

  return `/lookup?q=${encodeURIComponent(detection.query)}`;
}

/**
 * @returns {{ chain: string, type: string, query: string, label: string, chainLabel: string } | null}
 */
export function getSearchSuggestion(query) {
  const detection = detectBlockchainInput(query);
  if (!detection) {
    return null;
  }

  return {
    ...detection,
    chainLabel: getChainLabel(detection.chain),
    typeLabel: getTypeLabel(detection.type),
    iconChain: detection.chain,
  };
}

export function truncateQuery(query, max = 42) {
  const text = String(query || '');
  if (text.length <= max) {
    return text;
  }
  return `${text.slice(0, 18)}…${text.slice(-12)}`;
}
